import { SitesBuilderLibComponent, Colormap } from '@3ddv/ngx-sites-builder-lib';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { SblibService } from '../../../services/sblib.service';
import { ToolsService } from '../../services/tools.service';
import { default_colors } from '../models/default.model';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss']
})
export class DefaultComponent implements OnInit, OnDestroy {
@Input() currenttab: any;
@Input() master_default_colors: default_colors;
@Output() refresh = new EventEmitter<default_colors>();
private tool: Colormap;
private subscriptions: Array<Subscription>;
public hiddenColors: {
  section?:boolean,
  seat?: boolean,
  areaprice?: boolean
};

  constructor(private toolsService: ToolsService, private sblibService: SblibService, private toastrService: ToastrService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      this.tool = res.colormap;
    });
    this.subscriptions.push(tools$);
    this.hiddenColors = {
      section:false,
      seat: false,
      areaprice: false
    };
  }

  ngOnDestroy(): void{
    this.subscriptions.forEach(o=>o.unsubscribe())
  }

  public copyDefaultToCustom(){
    this.refresh.emit(this.master_default_colors);
  }

  public applyDefaultStyles(){
    this.tool = {
      manual: {},
      default: true
    }

    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      res.colormap = JSON.parse(JSON.stringify(this.tool));
      this.sblibService.apply(res);
      this.toastrService.success("","Success")
    });
    this.subscriptions.push(tools$);
  }

}
